/* Summa theme — global scripts (no dependencies) */
(function () {
  'use strict';

  var S = window.Summa || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Helpers ---------- */
  function formatMoney(cents) {
    var n = Math.round(Number(cents) / 100);
    return (S.moneyPrefix || 'Rs. ') + n.toLocaleString('en-US');
  }
  S.formatMoney = formatMoney;

  function toast(msg) {
    var t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.hidden = true; }, 2600);
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  /* ---------- Sticky header shadow ---------- */
  var headerSection = $('.section-header');
  if (headerSection) {
    var onScroll = function () { headerSection.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return false;
    lastFocus = document.activeElement;
    d.hidden = false;
    document.body.classList.add('has-drawer');
    requestAnimationFrame(function () {
      d.classList.add('is-open');
      var panel = $('.drawer__panel', d);
      if (panel) panel.focus();
    });
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    return true;
  }
  function closeDrawer(d) {
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () {
      d.hidden = true;
      if (!$('.drawer.is-open')) document.body.classList.remove('has-drawer');
    }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  S.openDrawer = openDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var id = opener.getAttribute('data-drawer-open');
      if (id === 'CartDrawer' && S.cartType !== 'drawer') return;
      if (document.getElementById(id)) {
        e.preventDefault();
        openDrawer(id);
      }
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    closeQuickView();
    $$('.nav__item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
  });

  /* ---------- Desktop nav: keyboard / touch support ---------- */
  $$('.nav__item--has-children > .nav__link').forEach(function (link) {
    var item = link.parentElement;
    item.addEventListener('mouseenter', function () { link.setAttribute('aria-expanded', 'true'); });
    item.addEventListener('mouseleave', function () { link.setAttribute('aria-expanded', 'false'); item.classList.remove('is-open'); });
    link.addEventListener('click', function (e) {
      // On touch devices the first tap opens the menu, the second follows the link
      if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) {
        e.preventDefault();
        $$('.nav__item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
        item.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---------- Search: category select + predictive ---------- */
  $$('[data-search-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var sel = $('[data-search-category]', form);
      if (sel && !sel.value) sel.disabled = true;
      setTimeout(function () { if (sel) sel.disabled = false; }, 500);
    });

    var input = $('[data-predictive-input]', form);
    var box = $('[data-predictive-results]', form);
    if (!input || !box || !S.routes.predictiveSearch) return;
    var controller;
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { box.hidden = true; input.setAttribute('aria-expanded', 'false'); return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = S.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=predictive-search';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var inner = $('.predictive__inner', doc);
          box.innerHTML = inner ? inner.outerHTML : '';
          box.hidden = !inner;
          input.setAttribute('aria-expanded', inner ? 'true' : 'false');
        })
        .catch(function () {});
    }, 260);
    input.addEventListener('input', run);
    input.addEventListener('focus', function () { if (box.innerHTML.trim() && input.value.trim().length > 1) box.hidden = false; });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) box.hidden = true; });
    form.addEventListener('keydown', function (e) { if (e.key === 'Escape') { box.hidden = true; input.blur(); } });
  });

  /* ---------- Cart ---------- */
  function updateCartUI(cart, sections) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) el.removeAttribute('data-empty'); else el.setAttribute('data-empty', '');
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
    $$('[data-cart-count-text]').forEach(function (el) { el.textContent = cart.item_count; });
    $$('[data-cart-total]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });

    if (sections && sections['cart-drawer']) {
      var drawer = document.getElementById('CartDrawer');
      var fresh = $('#CartDrawer .drawer__panel', parseHTML(sections['cart-drawer']));
      if (drawer && fresh) {
        var panel = $('.drawer__panel', drawer);
        panel.innerHTML = fresh.innerHTML;
      }
    }
    var page = $('[data-cart-page]');
    if (page && sections) {
      var sid = page.getAttribute('data-cart-page');
      if (sections[sid]) {
        var freshPage = $('[data-cart-page]', parseHTML(sections[sid]));
        if (freshPage) page.innerHTML = freshPage.innerHTML;
      }
    }
  }

  function sectionsToRender() {
    var list = [];
    if (document.getElementById('CartDrawer')) list.push('cart-drawer');
    var page = $('[data-cart-page]');
    if (page) list.push(page.getAttribute('data-cart-page'));
    return list;
  }

  function fetchCart() {
    return fetch(S.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function addToCart(formData) {
    var secs = sectionsToRender();
    if (secs.length) {
      formData.append('sections', secs.join(','));
      formData.append('sections_url', window.location.pathname);
    }
    return fetch(S.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || S.strings.error);
        return data;
      });
    });
  }

  function changeLine(key, quantity) {
    var secs = sectionsToRender();
    return fetch(S.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: secs, sections_url: window.location.pathname })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || S.strings.error);
        return data;
      });
    });
  }

  // Add-to-cart forms (product cards, product page, quick view)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = $('[data-atc]', form) || form.querySelector('[type="submit"]');
    submitProductForm(form, btn, false);
  });

  function submitProductForm(form, btn, buyNow) {
    var err = $('[data-form-error]', form);
    if (err) err.hidden = true;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(form);
    if (buyNow) {
      fetch(S.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw new Error(d.description || S.strings.error); }); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (ex) { showError(ex); });
      return;
    }
    addToCart(fd)
      .then(function (data) {
        return fetchCart().then(function (cart) {
          updateCartUI(cart, data.sections);
          closeQuickView();
          if (S.cartType === 'drawer' && document.getElementById('CartDrawer')) {
            openDrawer('CartDrawer');
          } else {
            toast('Added to cart: ' + (data.product_title || data.title || ''));
          }
        });
      })
      .catch(showError)
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });

    function showError(ex) {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
      if (err) { err.textContent = ex.message; err.hidden = false; } else { toast(ex.message); }
    }
  }

  document.addEventListener('click', function (e) {
    var bn = e.target.closest('[data-buy-now]');
    if (bn) {
      var form = bn.closest('form');
      if (form) { e.preventDefault(); submitProductForm(form, bn, true); }
    }
  });

  // Cart line quantity changes (drawer + cart page)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-change]');
    if (!b) return;
    var line = b.closest('[data-key]');
    if (!line) return;
    e.preventDefault();
    line.classList.add('is-updating');
    changeLine(line.getAttribute('data-key'), parseInt(b.getAttribute('data-qty-change'), 10))
      .then(function (cart) { updateCartUI(cart, cart.sections); })
      .catch(function (ex) { line.classList.remove('is-updating'); toast(ex.message); });
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) {
      var line = input.closest('[data-key]');
      if (!line) return;
      line.classList.add('is-updating');
      changeLine(line.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0))
        .then(function (cart) { updateCartUI(cart, cart.sections); })
        .catch(function (ex) { line.classList.remove('is-updating'); toast(ex.message); });
      return;
    }
    var note = e.target.closest('[data-cart-note]');
    if (note) {
      fetch(S.routes.cart + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    }
    var auto = e.target.closest('[data-auto-submit]');
    if (auto && auto.form) auto.form.submit();
  });

  // Product page quantity steppers
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, v);
  });

  /* ---------- Variant picker ---------- */
  function initProduct(root) {
    if (!root || root._init) return;
    root._init = true;
    var picker = $('[data-variant-picker]', root);
    var jsonEl = $('[data-variants-json]', root);
    if (!picker || !jsonEl) return;
    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (ex) { return; }
    var isMain = !root.closest('.quick-view');
    var section = root.closest('.section, .qv');

    function selectedOptions() {
      var groups = $$('.variants__group', picker);
      return groups.map(function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function markAvailability(opts) {
      // Grey out values that have no available variant combined with the other current choices
      $$('.variants__group', picker).forEach(function (g, gi) {
        $$('input', g).forEach(function (inp) {
          var test = opts.slice(); test[gi] = inp.value;
          var match = variants.some(function (v) { return v.available && v.options.every(function (o, i) { return o === test[i]; }); });
          var label = g.querySelector('label[for="' + inp.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !match);
        });
      });
    }

    function update() {
      var opts = selectedOptions();
      $$('[data-option-value]', picker).forEach(function (el) { el.textContent = opts[parseInt(el.getAttribute('data-option-value'), 10)] || ''; });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      markAvailability(opts);
      var atc = $('[data-atc]', root), lbl = $('[data-atc-label]', root), bn = $('[data-buy-now]', root);
      var stock = $('[data-stock]', root);
      if (!v) {
        if (atc) atc.disabled = true;
        if (bn) bn.disabled = true;
        if (lbl) lbl.textContent = S.strings.unavailable;
        if (stock) { stock.textContent = S.strings.unavailable; stock.classList.add('is-out'); }
        return;
      }
      $('[data-variant-id]', root).value = v.id;
      if (atc) atc.disabled = !v.available;
      if (bn) bn.disabled = !v.available;
      if (lbl) lbl.textContent = v.available ? S.strings.addToCart : S.strings.soldOut;
      if (stock) {
        stock.classList.toggle('is-out', !v.available);
        stock.innerHTML = v.available ? '<svg class="icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12l5 5L19 7"/></svg>In stock' : S.strings.soldOut;
      }
      var price = $('[data-price]', root), cmp = $('[data-compare-price]', root), badge = $('[data-discount-badge]', root), save = $('[data-save]', root);
      var wrap = $('[data-price-wrapper]', root);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (price) price.textContent = formatMoney(v.price);
      if (wrap) wrap.classList.toggle('price--sale', !!onSale);
      if (cmp) { cmp.hidden = !onSale; cmp.textContent = onSale ? formatMoney(v.compare_at_price) : ''; }
      if (badge) { badge.hidden = !onSale; badge.textContent = onSale ? '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%' : ''; }
      if (save) { save.hidden = !onSale; save.textContent = onSale ? 'You save ' + formatMoney(v.compare_at_price - v.price) : ''; }
      if (v.featured_media && section) showMedia(section, v.featured_media.id);
      if (isMain && root.getAttribute('data-url') && window.history.replaceState) {
        try { window.history.replaceState({}, '', root.getAttribute('data-url') + '?variant=' + v.id); } catch (ex) {}
      }
    }
    picker.addEventListener('change', update);
    markAvailability(selectedOptions());
  }

  /* ---------- Gallery ---------- */
  function showMedia(scope, mediaId) {
    var main = $('[data-gallery-main]', scope);
    if (!main) return;
    var slide = $('[data-media-id="' + mediaId + '"]', main);
    if (!slide) return;
    main.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    setActiveThumb(scope, mediaId);
  }
  function setActiveThumb(scope, mediaId) {
    $$('[data-thumb]', scope).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(mediaId)); });
  }
  function initGallery(g) {
    if (g._init) return;
    g._init = true;
    var main = $('[data-gallery-main]', g);
    if (!main) return;
    // Jump to the initially active slide (selected variant)
    var active = $('.gallery__slide.is-active', main);
    if (active && active.offsetLeft) main.scrollLeft = active.offsetLeft;
    $$('[data-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () { showMedia(g, t.getAttribute('data-thumb')); });
    });
    var dots = $$('.gallery__dot', g);
    main.addEventListener('scroll', debounce(function () {
      var i = Math.round(main.scrollLeft / main.clientWidth);
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      var slides = $$('.gallery__slide', main);
      if (slides[i]) setActiveThumb(g, slides[i].getAttribute('data-media-id'));
    }, 60), { passive: true });
  }

  /* ---------- Tabs ---------- */
  function initTabs(t) {
    var tabs = $$('[role="tab"]', t);
    function activate(tab) {
      tabs.forEach(function (x) {
        var on = x === tab;
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(tab); });
      tab.addEventListener('keydown', function (e) {
        var n = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!n) return;
        var next = tabs[(i + n + tabs.length) % tabs.length];
        next.focus(); activate(next);
      });
    });
    // "See reviews" link opens the reviews tab
    $$('a[href="#ProductReviews"]').forEach(function (a) {
      a.addEventListener('click', function () {
        var tab = tabs.find(function (x) { return x.getAttribute('aria-controls') === 'ProductReviews'; });
        if (tab) activate(tab);
      });
    });
  }

  /* ---------- Hero slider ---------- */
  function initSlider(track) {
    var slides = $$('[data-slide]', track);
    if (slides.length < 2) return;
    var root = track.parentElement;
    var dots = $$('[data-slider-dot]', root);
    var idx = 0, timer = null;
    var delay = (parseInt(track.getAttribute('data-autoplay'), 10) || 5) * 1000;
    var auto = !track.hasAttribute('data-autoplay-off') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goSimple(i) {
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
    }
    function setDots() { dots.forEach(function (d, di) { d.classList.toggle('is-active', di === idx); }); }
    function start() { if (!auto) return; stop(); timer = setInterval(function () { goSimple(idx + 1); }, delay); }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    track.addEventListener('scroll', debounce(function () {
      idx = Math.round(track.scrollLeft / track.clientWidth);
      setDots();
    }, 60), { passive: true });
    dots.forEach(function (d) { d.addEventListener('click', function () { goSimple(parseInt(d.getAttribute('data-slider-dot'), 10)); start(); }); });
    var prev = $('[data-slider-prev]', root), next = $('[data-slider-next]', root);
    if (prev) prev.addEventListener('click', function () { goSimple(idx - 1); start(); });
    if (next) next.addEventListener('click', function () { goSimple(idx + 1); start(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    track.addEventListener('touchstart', stop, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
  }

  /* ---------- Product carousels ---------- */
  function initCarousel(c) {
    var track = $('[data-carousel-track]', c);
    var prev = $('[data-carousel-prev]', c), next = $('[data-carousel-next]', c);
    if (!track) return;
    function step() { var item = track.firstElementChild; return item ? item.getBoundingClientRect().width + 16 : 240; }
    function sync() {
      if (prev) prev.disabled = track.scrollLeft < 8;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', debounce(sync, 50), { passive: true });
    window.addEventListener('resize', debounce(sync, 150));
    sync();
  }

  /* ---------- Countdown ---------- */
  function initCountdown(el) {
    var raw = (el.getAttribute('data-countdown') || '').trim();
    var repeat = el.getAttribute('data-countdown-repeat') === 'true';
    // Interpret as Pakistan time (UTC+5)
    var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
    if (!m) { el.hidden = true; return; }
    var end = Date.UTC(+m[1], +m[2] - 1, +m[3], (+m[4] || 0) - 5, +m[5] || 0);
    var d = $('[data-cd-d]', el), h = $('[data-cd-h]', el), mi = $('[data-cd-m]', el), s = $('[data-cd-s]', el);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = Date.now();
      var diff = end - now;
      if (diff <= 0) {
        if (!repeat) { el.hidden = true; clearInterval(iv); return; }
        // Count down to the next Pakistan midnight
        var pk = new Date(now + 5 * 3600 * 1000);
        end = Date.UTC(pk.getUTCFullYear(), pk.getUTCMonth(), pk.getUTCDate() + 1, -5, 0);
        diff = end - now;
      }
      var sec = Math.floor(diff / 1000);
      d.textContent = pad(Math.floor(sec / 86400));
      h.textContent = pad(Math.floor(sec % 86400 / 3600));
      mi.textContent = pad(Math.floor(sec % 3600 / 60));
      s.textContent = pad(sec % 60);
    }
    var iv = setInterval(tick, 1000);
    tick();
  }

  /* ---------- Quick view ---------- */
  var qv = $('#QuickView');
  function closeQuickView() {
    if (!qv || qv.hidden) return;
    qv.hidden = true;
    document.body.classList.remove('has-drawer');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view]');
    if (trigger && qv && window.matchMedia('(min-width: 750px)').matches) {
      e.preventDefault();
      lastFocus = trigger;
      var content = $('#QuickViewContent');
      content.innerHTML = '';
      content.classList.add('is-loading');
      qv.hidden = false;
      document.body.classList.add('has-drawer');
      var url = trigger.getAttribute('data-quick-view');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-view')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var inner = $('.qv', doc);
          content.classList.remove('is-loading');
          if (!inner) { window.location.href = url; return; }
          content.innerHTML = inner.outerHTML;
          initAll(content);
          var close = $('.quick-view__close', qv);
          if (close) close.focus();
        })
        .catch(function () { window.location.href = url; });
      return;
    }
    if (e.target.closest('[data-quick-view-close]')) closeQuickView();
  });

  /* ---------- Product recommendations ---------- */
  function initRecommendations(el) {
    var url = el.getAttribute('data-recommendations');
    if (!url || el.children.length) return;
    var load = function () {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var fresh = $('[data-recommendations]', parseHTML(html));
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          initAll(el);
        }
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(el);
    } else { load(); }
  }

  /* ---------- Misc ---------- */
  document.addEventListener('click', function (e) {
    var r = e.target.closest('[data-toggle-recover]');
    if (!r) return;
    e.preventDefault();
    var login = $('#LoginBox'), rec = $('#RecoverBox');
    if (login && rec) { login.hidden = !login.hidden; rec.hidden = !rec.hidden; }
  });
  if (window.location.hash === '#recover') {
    var lb = $('#LoginBox'), rb = $('#RecoverBox');
    if (lb && rb) { lb.hidden = true; rb.hidden = false; }
  }
  $$('select[data-default]').forEach(function (sel) {
    var v = sel.getAttribute('data-default');
    $$('option', sel).forEach(function (o) { if (o.value === v || o.textContent.trim() === v) o.selected = true; });
  });

  /* ---------- Init ---------- */
  function initAll(root) {
    $$('[data-product-root]', root).forEach(initProduct);
    $$('[data-gallery]', root).forEach(initGallery);
    $$('[data-tabs]', root).forEach(initTabs);
    $$('[data-carousel]', root).forEach(initCarousel);
  }
  function boot(root) {
    initAll(root);
    $$('[data-slider]', root).forEach(initSlider);
    $$('[data-countdown]', root).forEach(initCountdown);
    $$('[data-recommendations]', root).forEach(initRecommendations);
  }
  boot(document);

  // Theme editor: re-init sections when they are added or changed
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
